import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { setUserData } from '../../Redux/ActionCreater';
import axios from 'axios';
import { BASE_IMAGE_URL, BASE_URL } from '../../config';
import { toast } from 'react-toastify';
import { FaCamera } from "react-icons/fa";
import logo from "../../Assets/images/bwu-logo.webp";
import { PiSignOutBold } from "react-icons/pi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { FaCircleCheck } from "react-icons/fa6";

function DashboardHeader({sidebar}) {
    const today = new Date();
    let navigation = useNavigate();
    let dispatch = useDispatch();
    // Format the date as needed (e.g., "Mar 23")
    const formattedDate = today.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
    });

    let logout = (e) => {
        toast.dismiss()
        e.preventDefault();
        localStorage.clear();
        dispatch(setUserData({}));
        toast.success("You are logged out successfully!");
        navigation('/');
    }


    return (
        <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
            <div className="navbar-brand-wrapper d-flex justify-content-center">
                <div className="navbar-brand-inner-wrapper d-flex justify-content-between align-items-center w-100">
                    <Link className="navbar-brand brand-logo" to={"/dashboard"}><img src={logo} alt="logo" /></Link>
                   {sidebar&& <button  onClick={(e)=>{document.body.classList.toggle('sidebar-icon-only');}} className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                        <span className="typcn typcn-th-menu" />
                    </button>}
                </div>
            </div>
            <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                <ul className="navbar-nav navbar-nav-right">
                    <li className="nav-item nav-date dropdown fsttody" >
                        <a className="nav-link d-flex justify-content-center align-items-center" href="javascript:;">
                            <i><FaRegCalendarAlt /></i>
                            <h6 className="date mb-0">Today : {formattedDate}</h6> 
                        </a>
                        {/* <a className="nav-link d-flex justify-content-center align-items-center pt-0" href="javascript:;">
                            <i><FaRegCalendarAlt /></i>
                            <h6 className="date mb-0">Log in : {formattedDate}</h6> 
                        </a> */}
                    </li>
                    <li className="nav-item dropdown">
                        <NavLink to={"/logout"} onClick={logout} style={{cursor:"pointer"}} className="nav-link d-flex justify-content-center align-items-center" >
                            <i><PiSignOutBold /></i>
                            <h6 className="date mb-0">Logout</h6>
                            
                        </NavLink>
                    </li>
                </ul>
                <button id='toggleicon' onClick={(e)=>{document.body.classList.toggle('sidebar-icon-only');}} className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
                    <span id='toggleicon' className="typcn typcn-th-menu" />
                </button>
            </div>
        </nav>


    )
}

export default DashboardHeader